import type { DropdownLayoutUniDriver } from '../DropdownLayout/DropdownLayout.uni.driver';
import type { PopoverNextUniDriver } from '../PopoverNext/PopoverNext.uni.driver';
import type { InputUniDriver } from '../Input/Input.uni.driver';

/**
 * Used in InputWithOptions.uni.driver only.
 *
 * Because popover content (with dropdown inside) is rendered conditionally, this proxy
 * updates some dropdown methods.
 */
export const dropdownLayoutDriverProxy = (
  drodownLayoutFromRoot: () => DropdownLayoutUniDriver,
  dropdownLayoutTestkit: () => Promise<DropdownLayoutUniDriver | undefined>,
  popoverTestkit: () => PopoverNextUniDriver,
  inputDriver: InputUniDriver,
): DropdownLayoutUniDriver => {
  const proxiedMethods = Object.keys(drodownLayoutFromRoot()).reduce(
    (prev, current) => {
      return {
        ...prev,
        [current]: async (...args: any[]) => {
          const isPopoverShown =
            await popoverTestkit().isContentElementExists();

          if (current === 'isShown' || current === 'exists') {
            return isPopoverShown;
          }
          if (current === 'getDropdown' || current === 'getDropdownItem') {
            return isPopoverShown
              ? //@ts-ignore
                (await dropdownLayoutTestkit())[current](...args)
              : { isDisplayed: () => false };
          }

          !isPopoverShown && (await inputDriver.click());
          //@ts-ignore
          return await (await dropdownLayoutTestkit())[current](...args);
        },
      };
    },
    {},
  ) as DropdownLayoutUniDriver;

  return { ...proxiedMethods };
};
